import { Paper, Stack } from "@mui/material";
import React, { Fragment } from "react";
import logoWhite from "../../assets/svg/ZookeeperLogoWhite.svg";
import logoBlue from "../../assets/svg/ZookeeperLogo.svg";
import { PRIMARY_BLUE } from "../../enums/Colors";
import { HOME } from "../../enums/UrlPaths";
import LinkTo from "../wrappers/LinkTo";
import { ThemeContext } from "../../contexts/ThemeContext";
import usePrimaryColor from "../../hooks/usePrimaryColor";

export default function HeaderNoAuth({ children }) {
  const { mode } = React.useContext(ThemeContext);
  const isDark = mode == "dark";
  const primaryColor = usePrimaryColor();
  const headerLogo = isDark ? logoBlue : logoWhite;

  return (
    <Fragment>
      <Paper sx={{ bgcolor: isDark ? "" : primaryColor, borderRadius: 0, boxShadow: "none" }}>
        <Stack
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ height: 60 }}
        >
          <LinkTo to={HOME}>
            <img src={headerLogo} width="200px" alt="Logo" />
          </LinkTo>
        </Stack>
      </Paper>
      {children}
    </Fragment>
  );
}
